import { render } from "./UIAvatar.vue?vue&type=template&id=9dad223e"
import script from "./UIAvatar.vue?vue&type=script&lang=js"
export * from "./UIAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__